import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../routes/AppRoutes';
import { strings } from '../../resources/strings';
import { useAuth } from '../../contexts/AuthContext';
import ServicesContext from '../../contexts/ServicesContext';
import { Button } from '../../common-components/Button/Button';
import { Field, FieldType } from '../../common-components/Field/Field';
import { Header } from '../../common-components/Layout/Header/Header';
import { Page } from '../../common-components/Layout/Page/Page';
import { Panel } from '../../common-components/Layout/Panel/Panel';
import { FormLogin } from '../../components/FormLogin/FormLogin';

const Login: React.FC = () => {

  const [login, setLogin] = useState<string>();
  const [password, setPassword] = useState<string>();

  const navigate = useNavigate();
  const { signIn } = useAuth();
  const { toastService } = React.useContext(ServicesContext);

  const headerRender = (
    <Header title={strings.Login} userMenu={false} />
  );

  return (
    <Page header={headerRender}>
      <FormLogin>
        <Field label={strings.User} value={login} change={(value) => setLogin(value)} />
        <Field label={strings.Password} value={password} change={(value) => setPassword(value)} type={FieldType.Password} />
        <Panel marginTop='10px' alignItems='flex-start'>
          <Button text={strings.Enter} width='100%' click={clickEnter} />
        </Panel>
      </FormLogin>
    </Page>
  );

  function clickEnter() {
    if (!login || !password) {
      toastService.warning(strings.InformUserAndPassword);
      return;
    }

    let finalLogin = login.trim();
    if (!finalLogin.includes('@') && !finalLogin.endsWith('@zerezes.com.br')) {
      finalLogin += '@zerezes.com.br';
    }

    signIn(finalLogin, password, (success: boolean, message: string) => {
      if (!success) {
        let msg = message ? message : strings.UserNotFound;
        toastService.warning(msg);
        return;
      }
      navigate(routes.Home);
    });
  }
}

export default Login;